import React, { Component } from 'react'
import { IMG, COLOR, getFontContrastColor } from '../../themes'
import { FILTER_DEFAULT } from '../../helpers'
import { FilterSelectStyle } from './style'

export class FilterSelect extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isOpen: false
    }
  }

  getOptionLabel(label) {
    return typeof label === 'object' ? label[this.props.language] : label
  }

  render() {
    const { value, options, placeholder, onChange } = this.props
    const { isOpen } = this.state
    const selectedOption = options.find(o => o.value === value)
    const displayText = selectedOption && value !== FILTER_DEFAULT ? this.getOptionLabel(selectedOption.label) : placeholder
    const colorTheme = this.props.colorTheme || '#CFB58F'
    const contrastColor = getFontContrastColor(colorTheme)

    return (
      <FilterSelectStyle>
        <div 
          className="custom-select-trigger"
          onClick={() => this.setState(prev => ({ isOpen: !prev.isOpen }))}
        >
          <span className={`custom-select-text${value !== FILTER_DEFAULT ? ' selected' : ''}`}>{displayText}</span>
          <img 
            src={IMG['ic_expand-more.svg']} 
            alt="expand" 
            className="custom-select-icon"
            style={{ 
              transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)' 
            }} 
          />
        </div>
        
        {isOpen && (
          <>
            <div 
              className="dropdown-overlay"
              onClick={() => this.setState({ isOpen: false })} 
            />
            <div className="custom-select-dropdown">
              {options.filter(opt => !opt.hideInMenu).map(opt => {
                const isSelected = opt.value === value;
                return (
                  <div 
                    key={opt.value}
                    className="dropdown-option"
                    style={{
                      color: isSelected ? contrastColor : COLOR.BLACK_5,
                      backgroundColor: isSelected ? colorTheme : 'transparent',
                    }}
                    onClick={() => {
                       onChange(opt.value);
                       this.setState({ isOpen: false });
                    }}
                    onMouseEnter={(e) => {
                      if (!isSelected) {
                        e.currentTarget.style.backgroundColor = colorTheme;
                        e.currentTarget.style.color = contrastColor;
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (!isSelected) {
                        e.currentTarget.style.backgroundColor = 'transparent';
                        e.currentTarget.style.color = COLOR.BLACK_5;
                      }
                    }}
                  >
                    {this.getOptionLabel(opt.label)}
                  </div>
                )
              })}
            </div>
          </>
        )}
      </FilterSelectStyle>
    )
  }
}
